export default { MOBILE_SCREEN_WIDTH: 568 };
